'use strict';

var addProductToCart = require('./product/addToCart'),
	ajax = require('../ajax'),
	image = require('./product/image'),
	sizeChart = require("../sizechart"),
	validator = require('../validator'),
	util = require('../util'),
	progress = require('../progress'),
	tealium = require('../../../../int_tealium/cartridge/js/tealium/tealium'),
	dialog = require('../dialog');
/**
 * @description update product content with new variant from href, load new content to .mm-prod-details panel
 * @param {String} href - url of the new product variant
 * @param {String} target - panel to load new content
 **/
var updateContent = function(href,target,$content,$slider) {
	var tileInfo = false;
	if ($slider != undefined && $slider != null) {
		tileInfo = $slider;
	}
    var params = {
        Quantity: 1,
        format: 'ajax',
        tile: tileInfo
    };
    if ($content != null && !$slider) {
    	progress.show($content);
	}
    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: target,
        callback: function() {
            image.replaceImages();
            validator.init();
            util.updateselect();
            if($content != undefined && $content != null) {
            	$content.find('.slick-center .special-product-swatches.color-details .attribute.color').html($content.find('.special-product-swatches.content-detail .attribute.color').html());
            	util.updateselect();
            	if (!tileInfo) {
            		var imgURL = $content.find('.slick-center .color-details .attribute.color .selected a.swatchanchor').data('imageurl');
                	$content.find('.slick-center .special-product-tile .product-image img').attr('src',imgURL);
            	} else if ($slider) {
            		var imgURL = $content.find('.slick-center .color-details .attribute.color .selected a.swatchanchor').data('imageurl');
                	$content.find('.slick-center .special-product-tile .product-image img').attr('src',imgURL);
            	}
            }
            progress.hide();
        }
    });
};

/**
 * @description Initialize event handlers on mix and match page
 */
function initializeEvents() {
	sizeChart.init();
    $('.mm-slider').slick({
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 3,
        adaptiveHeight: true,
        responsive: [{
                breakpoint: 1025,
                settings: {
                    centerMode: false,
                    centerPadding: '70px',
                    slidesToShow: 1,
                    slidesToSroll: 1,
                    dots: true,
                    dotsClass: 'custom_paging',
                    customPaging: function(slider, i) {
                        return (i + 1) + '/' + slider.slideCount;
                    }
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    centerMode: true,
                    centerPadding: '70px',
                    slidesToShow: 1,
                    dots: false,
                    dotsClass: 'custom_paging',
                    /*customPaging: function(slider, i) {
                        return (i + 1) + '/' + slider.slideCount;
                    }*/
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    centerPadding: '0px',
                    slidesToShow: 1
                }
            }
        ]

    });



    if ($(window).width() < 767) {
        $('.togglemob').next('.togglemob-content').hide();
        $('.togglemob').click(function() {
            $(this).toggleClass('expanded').next('.togglemob-content').toggle();
        });
    }
    
    var $specialsMain = $('.special-result-content');
    $specialsMain.on('click touchstart', '.special-product-swatches .swatchanchor', function(e) {
        e.preventDefault();
        if ($(this).parents('li').hasClass('unselectable') || $(this).parents('li').hasClass('selected')) {
            return;
        }

        // adds selected class to li
        $('.special-product-swatches ul.swatches li').removeClass('selected');
        $(this).parent('li').addClass('selected')

        var $target = $(this).parents('div.special-result-content').find('.mm-prod-details');
        var $content = $(this).parents('div.special-result-content');
        updateContent(this.href, $target, $content);
        var obj = $(this).data("swatch");
    	
    	if(obj){
    		obj.collection_id = [];
    		obj.event_name = "product_interaction";
    		obj.product_viewtype = "standard";
    		if( typeof(obj.product_id)!= 'undefined' ){
    			obj.collection_id.push("mixMatch_"+obj.product_id);
    		}
			
    		tealium.triggerEvent(obj);
    	}
    });

    $specialsMain.on('change', '.variation-select', function() {
        if ($(this).val().length === 0) {
            return;
        }
        var $target = $(this).parents('div.special-result-content').find('.mm-prod-details');
        var $selectedVal = $(this).closest('.custom-select').find('select option:selected').text().trim();
        var $content = $(this).parents('div.special-result-content');
        updateContent($(this).val(), $target, $content);
        var obj = $(this).data("swatch");
    	if(obj){
    		obj.collection_id = [];
    		obj.event_name = "product_interaction";
    		obj.product_interaction_value = $selectedVal;
    		obj.product_viewtype = "standard";
    		if( typeof(obj.product_id)!= 'undefined' ){
    			obj.collection_id.push("mixMatch_"+obj.product_id);
    		}
			
    		tealium.triggerEvent(obj);
    	}
    });
    
    $specialsMain.off('click', '.mm-swatches-all').on('click', '.mm-swatches-all', function() {
    	var $curObj = $(this),
    		$parent = $curObj.closest("ul.swatches");
    	if(!$parent.find("li.more-less-colors").hasClass("active")) {
    		$parent.find("li.more-less-colors").addClass("active");
    		$parent.find("li.hide").addClass("show");
    		$curObj.text(Resources.MIXANDMATCH_LESS_COLOR);
    	} else {
    		$parent.find("li.more-less-colors").removeClass("active");
    		$parent.find("li.hide").removeClass("show");
    		$curObj.text(Resources.MIXANDMATCH_MORE_COLOR);
    	}
    });
    
    // Updates product details on change of Slick tile.
    var $slider = $('.mm-slider');
    $slider.on('afterChange',function(){
        var $target = $(this).parents('div.special-result-content').find('.mm-prod-details');
        var $purl = $(this).find('.slick-active.slick-current .special-product-tile').data('itemurl');
        var $content = $(this).parents('div.special-result-content');
        updateContent($purl, $target, $content, true);
    });
}

exports.init = function() {
    initializeEvents();
    addProductToCart();
};